import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormatNumberPipe } from './formatNumber/format-number.pipe';
import { ReplacePipe } from './replace/replace.pipe';
import { FormatUrlPipe } from './format-url/format-url.pipe';
import { TranslationsDataModule } from '../../data/translation/translations-data.module';
import { CdnPipe } from './cdn/cdn.pipe';
import { SingleTranslationPipe } from './single-translation/single-translation.pipe';
import { FormatBookingDatesPipe } from './format-booking-dates/format-booking-dates.pipe';
import { FormatDatePipe } from './format-date/format-date.pipe';
import { NoSanitizePipe } from './no-sanitize/no-sanitize.pipe';
import { ChunkPipe } from './chunk/chunk.pipe';

@NgModule({
    declarations: [
        FormatNumberPipe,
        ReplacePipe,
        FormatUrlPipe,
        CdnPipe,
        SingleTranslationPipe,
        FormatBookingDatesPipe,
        FormatDatePipe,
        NoSanitizePipe,
        ChunkPipe,
    ],
    imports: [CommonModule, TranslationsDataModule],
    exports: [
        FormatNumberPipe,
        ReplacePipe,
        FormatUrlPipe,
        CdnPipe,
        SingleTranslationPipe,
        FormatBookingDatesPipe,
        FormatDatePipe,
        NoSanitizePipe,
        ChunkPipe,
    ],
})
export class PipesModule {}
